import React from 'react'
import classes from "./EnergySolutions.module.scss"
import { ReactComponent as ClemLogo } from "../../../assets/icons/clemSolutionLogo.svg"
import { ReactComponent as ClemAiLogo } from "../../../assets/icons/clemAiSolutionLogo.svg"
import ArrowWithTail from '../../../assets/icons/ArrowWithTail'


const EnergySolutions = () => {
    return (
        <div className={classes["energy-solution-container"]} >
            <div className={classes['energy-solution-image']}>
                <div className={classes["img-overlay-container"]}>
                    <img
                        src={
                            "https://se-website-image.s3.ap-south-1.amazonaws.com/wind-mill.jpeg"
                        }
                        alt=""
                        className={classes["image-windmill"]}
                    />

                    <div className={classes.overlay}></div>
                </div>
                <div className={classes['image-text']}>
                    Our <br /> <span>Clean Energy Solutions</span> for a Greener Tomorrow
                </div>
            </div>
            <div className={classes['energy-solution-card-container']}>
                <div className={classes['clem-container']}>
                    <div className={classes['']} style={{ display: "flex", flexDirection: "column" }}>

                        <div className={classes['logo-conatiner']}>
                            <div className={classes['logo-frame']}>
                                <div className={classes['logo-inside-frame']}>
                                    <ClemLogo />
                                </div>
                            </div>
                        </div>
                        <div className={classes['content-container']}>
                            <div className={classes['content-heading']}>CLEM: Clean Energy Mechanism </div>
                            <div className={classes['content-body']}>CLEM embodies a vision of making clean energy transitions both profitable and practical, while enabling the development of new clean energy solutions. Built on a data-driven, thoughtfully designed platform, CLEM enables seamless transitions and unlocks new clean energy opportunities.</div>
                        </div>
                    </div>
                    <div className={classes['arrow']} onClick={() => window.open("/CLEM", "_blank")}>

                        <ArrowWithTail width="30px" height="50px" />
                    </div>
                </div>
                <div className={classes['clem-ai-container']}>
                    <div className={classes['']} style={{ display: "flex", flexDirection: "column" }}>
                        <div className={classes['logo-conatiner']}>
                            <div className={classes['logo-frame']}>
                                <div className={classes['logo-inside-frame']}>
                                    <ClemAiLogo />
                                </div>
                            </div>
                        </div>
                        <div className={classes['content-container']}>
                            <div className={classes['content-heading']}>CLEM.ai: Intelligent Energy Management </div>
                            <div className={classes['content-body']}>CLEM.ai is an AI-powered, intelligent energy management system designed to deliver the most optimal, reliable, and cost-effective energy blend. With its advanced architecture, CLEM.ai drives energy efficiency and accelerates clean energy adoption.</div>
                        </div>
                    </div>
                    <div className={classes['arrow']} onClick={() => window.open("/CLEM.ai", "_blank")}>

                        <ArrowWithTail width="30px" height="50px" />
                    </div>
                </div>
            </div>


        </div>
    )
}

export default EnergySolutions